<template>
  <div class="noticeManage" v-if="permisShow('公告查看')">
    <div class="sales_header">
      <div class="chouse_wrap" style="display: flex;justify-content: space-between">
        <ul class="conditions_list">
          <li class="conditions_list_item">
            <span>类型：</span>
            <el-select v-model="searchData.type" placeholder="请选择" @change="currentPage=1,pageNumber=1,getContralist()"
              clearable>
              <el-option v-for="(item,index) in typeList" :key="index" :label="item.valueDesc" :value="item.value">
              </el-option>
            </el-select>
          </li>
          <li class="conditions_list_item">
            <span>标题：</span>
            <div class="Residential">
              <el-input v-model="searchData.title" placeholder="请输入"
                @input="currentPage=1,pageNumber=1,getContralist()"></el-input>
            </div>
          </li>
          <li class="conditions_list_item total_price_input">
            <span>发布时间：</span>
            <span class="total_inp input_box">
              <el-date-picker v-model="searchData.publishDate" unlink-panels value-format="yyyy-MM-dd" type="daterange"
                :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                align="right" @change="GetDate"></el-date-picker>
            </span>
          </li>
        </ul>
        <el-button type="primary" style="width: 100px;height: 30px;line-height: 1px;margin-right: 20px;"
          @click="addnoticeManage" v-if="permisShow('公告新增')">新增</el-button>
      </div>
    </div>

    <div class="sales_list_wrap">
      <el-table ref="multipleTable" @row-dblclick="toDetails" :data="contractLsit" border style="width: 100%;"
        @row-click="rowColorclick" highlight-current-row>
        <el-table-column prop="typeName" label="类型" width="140px"></el-table-column>
        <el-table-column prop="title" label="标题" show-overflow-tooltip></el-table-column>
        <el-table-column prop="intercept" label="内容" show-overflow-tooltip></el-table-column>
        <el-table-column prop="publishPeople" label="发布人" width="100px"></el-table-column>
        <el-table-column prop="inputTime" label="发布时间" width="180px"></el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <div>
              <span style="margin-right:6px;color:#5e75e6;cursor:pointer" :class="{rowColor:scope.row.id===isRowColor}"
                @click="editnoticeManage(scope.row)" v-if="permisShow('公告编辑')">编辑</span>
              <span style="color:red;cursor:pointer" :class="{rowColor:scope.row.id===isRowColor}"
                @click="deletenoticeManage(scope.row)" v-if="permisShow('公告删除')">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer_page">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="20"
        layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
    </div>
    <el-dialog :visible.sync="activeShow" width="1000px" title="公告管理" :close-on-click-modal="false"
      :modal-append-to-body='false'>
      <templateNotice v-if="activeShow" @removeTem="activeShow=false"
        @saveTem="activeShow=false,currentPage=1,pageNumber=1,getContralist(),isRowColor=''" :id="id" :title="title"
        :type="type" :content="content"></templateNotice>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
/* eslint-disable */
import { dicGet } from "@/api";
import {
  queryNotice,
  addNotice,
  updateNotice,
  deleteNotice
} from "@/api/manageCenter";
import {
  query,
  queryMoHu,
  queryMoHuOwner,
  updateStatus
} from "@/api/contracManage";

import templateNotice from "@/components/common/templateNotice";
export default {
  // name: "公告管理",
  name: "/noticeManage",
  data() {
    let houseTypes = this.$store.state.houseType;
    let permisList = JSON.parse(sessionStorage.getItem("permisList"));
    return {
      permisList,
      isRowColor: "",
      textarea: "", //作废理由
      id: "",
      title: "",
      type: "",
      content: "",
      ResidentialName: "", //合同编号
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "本季度",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      typeList: [],
      contractLsit: [], //公告列表
      activeAddshow: false,
      value: "",
      officialList: [],
      activeShow: false, //显示退佣
      houseTypes,
      houseTypeJudge: true, //判断是否显示单价和总价
      searchHouseType: "", //查询状态房源类型
      houseType: "", //房源类型
      houseId: "", //房源编号
      pageNumber: 1,
      pageSize: 20,
      houseTypeId: "", //户型编号
      searchData: {
        type: "",
        title: "",
        publishDate: ""
      }, //搜索列表
      permissionLevel: "", //权限级别
      storeList: [], //门店列表
      addType: "新增出售",
      currentPage: 1,
      total: 0,
      checkList: [],
      dialogVisible: false,
      list: {}
    };
  },
  methods: {
    permisShow(data) {
      // 权限配置
      let result = this.permisList.indexOf(data);
      if (result >= 0) {
        return true;
      } else {
        return false;
      }
    },
    //修改当前行字体颜色
    rowColorclick(row) {
      this.isRowColor = row.id;
    },
    //查询类型
    getType() {
      let params = {
        code: "noticeType"
      };
      this.$post(dicGet, params).then(res => {
        if (res.success) {
          let a = { value: "", valueDesc: "不限" };
          this.typeList = res.data;
          this.typeList.unshift(a);
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    //新增黑名单
    addnoticeManage() {
      this.id = "";
      this.title = "";
      this.type = "";
      this.content = "";
      this.activeShow = true;
    },
    //编辑黑名单
    editnoticeManage(row) {
      this.id = row.id;
      this.title = row.title;
      this.type = row.type;
      this.content = row.content;
      this.activeShow = true;
    },
    //删除黑名单
    deletenoticeManage(row) {
      let params = {
        id: row.id
      };
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.$post(deleteNotice, params).then(res => {
            if (res.success) {
              this.$message({
                message: res.msg,
                type: "success"
              });
              this.currentPage = 1;
              this.pageNumber = 1;
              this.getContralist();
              this.isRowColor = "";
            } else {
              this.$message({
                message: res.msg,
                type: "error"
              });
            }
          });
        })
        .catch(() => {});
    },
    //签约时间
    GetDate() {
      this.currentPage = 1;
      this.pageNumber = 1;
      this.getContralist();
    },
    //查询公告列表
    getContralist() {
      this.isRowColor = "";
      let params = {
        "page.pageNumber": this.pageNumber * this.pageSize - this.pageSize,
        "page.pageSize": this.pageSize,
        type: this.searchData.type,
        title: this.searchData.title,
        publishDate: this.searchData.publishDate
      };
      this.$post(queryNotice, params).then(res => {
        if (res.success) {
          this.contractLsit = res.data;
          this.total = res.total;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getContralist(); //每页显示条数
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getContralist(); //当前页
    },
    //跳转详情
    toDetails(row) {
      sessionStorage.setItem("noticeId", row.id);
      this.$router.push("/noticeDetails");
    }
  },
  components: {
    templateNotice
  },
  mounted() {
    this.getContralist();
    this.getType(); //查询类型
    this.isRowColor = "";
  },
  activated() {
    this.getContralist();
    this.getType(); //查询类型
    this.isRowColor = "";
  }
};
</script>
<style type="text/css" lang="less">
.collect {
  width: 100%;
  height: 100%;
  cursor: pointer;
  i {
    color: #707070;
    &.active {
      color: red;
    }
  }
}
.el-checkbox {
  margin-top: 0;
}
.first_el_dropdown_menu {
  .icon-xiajiantou {
    margin-right: 5px;
  }

  .el-dropdown-menu {
    width: 240px;
    height: 280px;
  }

  #add_title {
    font-size: 14px;
    line-height: 14px;
    color: #999999;
    padding-left: 20px;
    margin-top: 5px;
  }

  .el-select-dropdown__list {
    margin-top: 15px;
  }

  .el-select-dropdown__empty {
    margin-top: 15px;
  }
  .el-popper .popper__arrow,
  .el-popper .popper__arrow::after {
    border: none;
  }

  .el-popper[x-placement^="bottom"] {
    margin-top: 0;
  }

  .el-dropdown-menu__item {
    float: left;
    width: 33.33%;
    display: flex;
    flex-direction: column;
    line-height: 15px;
    padding: 0;
    align-items: center;
    margin-top: 28px;
    color: #5e75e6;
    font-size: 14px;
    padding-top: 10px;
  }

  .add_font {
    font-size: 30px;
  }

  .add_sales {
    margin-top: 8px;
  }
}

.noticeManage {
  height: 100%;
  position: relative;
  .el-dialog__wrapper {
    z-index: 3 !important;
  }
  .v-modal {
    z-index: 2 !important;
  }
  .text {
    margin-bottom: 10px;
    vertical-align: middle;
  }
  .must {
    color: #f64e4e;
  }
  .el-table th.is-leaf {
    padding: 5px 0;
  }
  .set-brokerage-head {
    .el-button--primary {
      background: #5e75e6;
      width: 100px;
      height: 30px;
      font-size: 14px;
      line-height: 5px;
    }
  }
  .el-button {
    background: #999999;
    color: #ffffff;
  }
  .el-button--primary {
    background: #5e75e6;
  }
  .el-dialog__header {
    margin: 20px;
    .el-dialog__title {
      color: #5e75e6;
      font-size: 20px;
    }
  }

  .el-dialog__body {
    margin: 0 40px 30px 40px;
  }
  .sales_header {
    background: white;
    position: relative;

    .chouse_wrap {
      display: flex;
      height: 60px;
      align-items: center;
      .conditions_list {
        display: flex;
        > p {
          cursor: pointer;
          display: flex;
          align-items: center;
          margin-left: 10px;
          font-size: 14px;
          color: #bbb;

          .icon-xiajiantou {
            &.active {
              transform: rotate(180deg);
            }
          }

          > span {
            padding-left: 5px;
          }
        }

        .conditions_list_item {
          padding-left: 10px;
          display: flex;
          align-items: center;
          margin-left: 20px;
          > span {
            font-size: 12px;
            color: #666;
            padding: 4px 10px 4px 0;
            min-width: 24px;
          }
          .Residential {
            .el-input__inner {
              width: 140px;
              height: 30px;
              border: 1px solid #dbdbdb;
            }
            .el-input__icon {
              height: 30px;
              line-height: 30px;
            }
          }
          .Residential1 {
            .el-input__inner {
              width: 200px;
              height: 30px;
              border: 1px solid #dbdbdb;
            }
            .el-input__icon {
              height: 30px;
              line-height: 30px;
            }
          }

          .el-select {
            .el-input {
              .el-input__inner {
                width: 120px;
                height: 30px;
                border: 1px solid #dbdbdb;
              }

              .el-input__icon {
                height: 30px;
                line-height: 30px;
              }
            }
          }

          .el-input-group {
            .el-input-group__append {
              padding: 0 19px;
              background: #5e75e6;

              .icon-icon_sousuo {
                color: white;
              }
            }

            .el-input__inner {
              height: 30px;
              background: #f5f5f5;
              padding-left: 0;
              border: none;
              width: 120px;
            }
          }

          &.total_price_input {
            display: flex;
            height: 30px;

            .total_inp {
              display: flex;
              align-items: center;
              border: none;

              .el-range-editor.el-input__inner {
                height: 30px;
                line-height: 30px;
                .el-range-separator {
                  height: 30px;
                  line-height: 30px;
                }
                .el-input__icon {
                  height: 30px;
                  line-height: 30px;
                }
              }
            }
          }
        }
      }
      .button_list {
        button {
          padding: 6px 20px;
          background: #5e75e6;
          color: #ffffff;
          border: none;
          margin-left: 20px;
        }
        button:nth-child(2) {
          background: #f5f5f5;
          color: #5e75e6;
        }
      }
      .chouse_box {
        display: flex;

        .chouse_item {
          cursor: pointer;
          margin-left: 20px;
          text-align: center;

          > i {
            font-size: 20px;
            color: #999999;
          }

          > p {
            font-size: 14px;
            margin-top: 5px;
            color: #999999;
          }

          &.active {
            > i {
              color: #5e75e6;
            }

            > p {
              color: #5e75e6;
            }
          }
        }
      }

      .sales_line {
        width: 1px;
        height: 40px;
        background: #cccccc;
        margin-left: 10px;
      }

      .chouse_btns {
        margin-left: 20px;
        font-size: 14px;
        color: #999999;

        .sales_empty {
          margin-bottom: 10px;
        }

        > p {
          cursor: pointer;
          display: flex;
          align-items: center;

          > span {
            padding-left: 5px;
          }
        }
      }
    }
    .sales_contrast {
      min-width: 56px;
      padding: 5px 20px;
      background: #f5f5f5;
      margin-right: 34px;
      font-size: 14px;
      color: #ffffff;
      background: #5e75e6;
      border-radius: 3px;
      cursor: pointer;
      display: flex;
      align-items: center;

      .icon-icon_duibi {
        font-size: 24px;
      }
    }
  }
  .footer_page {
    position: absolute;
    right: 30px;
    padding: 20px;
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #5e75e6;
    }

    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      border: 1px solid #ccc;
      background: white;
    }
  }
}
</style>
